import { useTranslation } from "react-i18next";
import "./cartablePostList.scss";
import { useState } from "react";
import { Breadcrumb, Tabs } from "antd";
import { _adr } from "../../address";
import { HomeOutlined, InfoCircleOutlined, LeftOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import NewPurchase from "./newpurchase/newpurchase";
import PrintDocumentCartablePost from "./printDocument/printDocument";
import PrintBarCode from "./printBarcode/printBarcode";

const CartablePostList = () => {
  const [t] = useTranslation("global");

  const [tabCartablActive, setTabCartablActive] = useState("newPurchase");

  const changeTabHandler = (value) => {
    setTabCartablActive(value);
  };
  return (
    <>
      <div className="container-main container-post">
        <div className="g-hold-title-of-page">
          <Breadcrumb
            className="breadcrumbs"
            items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("cartablePost.title") }]}
          />
          <div className="title-page">
            <h3>{t("cartablePost.title")}</h3>
            <p></p>
          </div>
          <div className="holder-tab">
            <Tabs
              className="tab-postcartable"
              onChange={changeTabHandler}
              items={[
                { key: "newPurchase", label: "خریدهای جدید" },
                { key: "printDocument", label: "چاپ سند" },
                { key: "printBarcode", label: "چاپ بارکد" },
              ]}
            />
          </div>
        </div>
        <div className="g-layout-content">
          <Content className="g-layout-main post-container">
            <div className="g-format-page">
              {tabCartablActive === "newPurchase" && <NewPurchase />}
              {tabCartablActive === "printDocument" && <PrintDocumentCartablePost />}
              {tabCartablActive === "printBarcode" && <PrintBarCode />}
            </div>
          </Content>
        </div>
      </div>
    </>
  );
};

export default CartablePostList;
